module.exports = __webpack_public_path__ + "img/monitoring.e1a791d0.jpg";